export const LIVE_CHAT_UPDATE_STATUS = 'LIVE_CHAT_UPDATE_STATUS';
export const LIVE_CHAT_UPDATE_OPENED_STATUS = 'LIVE_CHAT_UPDATE_OPENED_STATUS';
